import React from "react";

export default function FacilityFeaturesSection() {
  const features = [
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="7" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      ),
      title: "Get discovered",
      desc: "Showcase your facility and capabilities to innovators, startups, industries and government organisations.",
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4.5 16.5c-1.5 1.5-2 5-2 5s3.5-.5 5-2c.8-.8 1-2 1-2s-1.2.2-2 1c0 0-.5-2 1-3.5" />
          <path d="M14 12l6-6c.9-.9 1.5-2.5 1.5-4 0 0-3.1.6-4 1.5l-6 6" />
          <path d="M12 15c-1.5-1.5-3-2-3-2s.5 3 2 4.5c1.7 1.7 4.5 2 4.5 2s-.3-2.8-2-4.5" />
          <path d="M9 9c-1.5-1.5-3.5-1-3.5-1s-.5 2 1 3.5c1.5 1.5 3.5 1 3.5 1" />
        </svg>
      ),
      title: "Get new business opportunities",
      desc: "Receive relevant prototype RFQs based on your machines, technologies and registered capabilities.",
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h0a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v0a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      ),
      title: "Manage everything digitally",
      desc: "Handle quotations, projects, work orders, teams, payments and facility utilisation from one platform.",
    },
  ];

  return (
    <section className="facility-features-section">
      <style>{`
        .facility-features-section {
          width: 100%;
          background: linear-gradient(180deg, #f7f9fd 0%, #eef1f8 100%);
          font-family: 'Inter', 'Segoe UI', sans-serif;
          box-sizing: border-box;
          padding: 30px 0;
        }
        .ff-wrap {
          width: 100%;
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 32px;
          display: grid;
          grid-template-columns: 1.05fr 0.95fr;
          gap: 56px;
          align-items: center;
          box-sizing: border-box;
        }
        .ff-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          padding: 9px 18px;
          border-radius: 999px;
          background: #fdecd3;
          font-family: 'Sora', 'Segoe UI', sans-serif;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.12em;
          color: #0b1330;
        }
        .ff-eyebrow-dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #f7941d;
          flex-shrink: 0;
        }
        .ff-heading {
          font-family: 'Sora', 'Segoe UI', sans-serif;
          font-weight: 800;
          font-size: clamp(1.9rem, 5vw, 3.4rem);
          line-height: 1.14;
          letter-spacing: -0.02em;
          color: #0b1330;
          margin-top: 24px;
        }
        .ff-accent { color: #f7941d; }
        .ff-paragraph {
          margin-top: 24px;
          max-width: 560px;
          font-size: clamp(0.95rem, 2.2vw, 1.05rem);
          line-height: 1.75;
          color: #5a6280;
        }
        .ff-card-col {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
        .ff-card {
          background: #ffffff;
          border: 1px solid #e7eaf3;
          border-radius: 18px;
          padding: 28px 30px;
          box-shadow: 0 20px 40px -28px rgba(11,19,48,0.18);
          box-sizing: border-box;
        }
        .ff-icon-box {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          background: #0b1330;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
        }
        .ff-card-title {
          font-family: 'Sora', 'Segoe UI', sans-serif;
          font-weight: 700;
          font-size: 1.2rem;
          color: #0b1330;
          margin: 0;
        }
        .ff-card-desc {
          margin-top: 10px;
          font-size: 0.98rem;
          line-height: 1.65;
          color: #6b7290;
        }

        /* Stack the two columns once there isn't room to sit side by side */
        @media (max-width: 900px) {
          .ff-wrap {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          .ff-paragraph { max-width: 100%; }
        }

        @media (max-width: 600px) {
          .facility-features-section { padding: 48px 0; }
          .ff-wrap { padding: 0 20px; gap: 32px; }
          .ff-card { padding: 24px 22px; }
        }
      `}</style>

      <div className="ff-wrap">
        {/* LEFT */}
        <div>
          <span className="ff-eyebrow">
            <span className="ff-eyebrow-dot" />
            WHAT IS APIC PROTOHUB FOR FACILITIES?
          </span>

          <h2 className="ff-heading">
            Your facility. Your
            <br />
            machines. <span className="ff-accent">More</span>
            <br />
            <span className="ff-accent">opportunities.</span>
          </h2>

          <p className="ff-paragraph">
            Many manufacturing facilities have advanced machines, skilled
            teams and valuable technical capabilities — but their capacity is
            not always fully utilised.
          </p>

          <p className="ff-paragraph">
            APIC ProtoHub creates a digital bridge between these capabilities
            and innovators who need access to manufacturing infrastructure.
            Register your facility to showcase capabilities to a larger
            innovation ecosystem and take on prototype development
            opportunities.
          </p>
        </div>

        {/* RIGHT */}
        <div className="ff-card-col">
          {features.map((f, i) => (
            <div className="ff-card" key={i}>
              <div className="ff-icon-box">{f.icon}</div>
              <h3 className="ff-card-title">{f.title}</h3>
              <p className="ff-card-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}